import React from 'react'
import PropTypes from 'prop-types'

export const MenuIcon = React.memo(({ isOpen = 'false', ...rest }) => {
  return !isOpen ? (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      data-cy="menu-icon-open"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7C3 6.17157 3.67157 5.5 4.5 5.5H19.5C20.3284 5.5 21 6.17157 21 7
           C21 7.82843 20.3284 8.5 19.5 8.5H4.5C3.67157 8.5 3 7.82843 3 7
           ZM3 12C3 11.1716 3.67157 10.5 4.5 10.5H19.5C20.3284 10.5 21 11.1716 21 12
           C21 12.8284 20.3284 13.5 19.5 13.5H4.5C3.67157 13.5 3 12.8284 3 12
           ZM4.5 15.5C3.67157 15.5 3 16.1716 3 17C3 17.8284 3.67157 18.5 4.5 18.5H19.5
           C20.3284 18.5 21 17.8284 21 17C21 16.1716 20.3284 15.5 19.5 15.5H4.5Z"
        fill="#121661"
      />
    </svg>
  ) : (
    <svg
      width="30"
      height="30"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      data-cy="menu-icon-close"
    >
      <rect opacity="0.06" width="36" height="36" rx="18" fill="#F1EFEA" />
      <path
        d="M0 18C0 8.05887 8.05887 0 18 0V0C27.9411 0 36 8.05887 36 18V18
           C36 27.9411 27.9411 36 18 36V36
           C8.05887 36 0 27.9411 0 18V18Z"
        fill="#D1F1FF"
      />
      <rect opacity="0.06" width="36" height="36" rx="18" fill="#F1EFEA" />
      <path
        d="M23.6066 12.9451C23.9971 12.5002 23.9971 11.7787 23.6066 11.3337
           C23.2161 10.8888 22.5829 10.8888 22.1924 11.3337L17.9503 16.1673
           L13.7083 11.3339C13.3178 10.8889 12.6846 10.8889 12.2941 11.3339
           C11.9036 11.7789 11.9036 12.5003 12.2941 12.9453L16.5361 17.7787
           L12.2929 22.6135C11.9024 23.0585 11.9024 23.7799 12.2929 24.2249
           C12.6834 24.6699 13.3166 24.6699 13.7071 24.2249L17.9503 19.3901
           L22.1936 24.2251C22.5841 24.6701 23.2173 24.6701 23.6078 24.2251
           C23.9983 23.7801 23.9983 23.0587 23.6078 22.6137L19.3645 17.7787
           L23.6066 12.9451Z"
        fill="#0C0C0D"
      />
    </svg>
  )
})

MenuIcon.displayName = 'MenuIcon'

MenuIcon.propTypes = {
  isOpen: PropTypes.bool,
}
